// removed by extract-text-webpack-plugin
module.exports = {"background-purple":"#eff0f4","white":"#ffffff","desktop-s":"1280px","displayerContainer":"nlhsH62ywjRES1--b6SGY","top":"SBZ0OfmJWpLJw8cwr5eXN","overlay":"pD-8mByffSbqT-kZwYqCL","bottom":"_1rftBA3fF8BN6c7-spEzE2","colorList":"QGghMnzcS14AvWAwpBP_-","fullScreenModal":"WVxdF54NVef6iHVeFub_i"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/foundations/Grids/GridDisplayer/GridDisplayer.css
// module id = 813
// module chunks = 0